import { HttpErrorResponse, HttpHeaders, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantSettingsStore } from 'app/core/tenant-settings/store/tenant-settings.store';
import { catchError, tap, throwError } from 'rxjs';

export const tenantSettingsVersionInterceptor: HttpInterceptorFn = (req, next) => {
    if (req.url.includes('api/tenant-settings')) {
        return next(req);
    }

    const store = inject(TenantSettingsStore);
    const check = (headers: HttpHeaders) => {
        const version = headers.get('X-Tenant-Settings-Version');
        // Retry after a failed initial load too (version stays null), but not before the initial load has run,
        // or the api/users/me response at login would fire a duplicate request.
        if (version && version !== store.version() && (store.isLoaded() || store.hasLoadTenantSettingsError())) {
            store.reloadTenantSettings();
        }
    };

    return next(req).pipe(
        tap(event => {
            if (event instanceof HttpResponse) {
                check(event.headers);
            }
        }),
        catchError((error: unknown) => {
            if (error instanceof HttpErrorResponse) {
                check(error.headers);
                if (error.status === 403 && error.error?.title === 'Feature.Disabled') {
                    store.reloadTenantSettings();
                }
            }
            return throwError(() => error);
        })
    );
};
